<template>
    <!--  <el-row>-->
    <!--    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">-->
    <!--      <div class="header-img-box">-->
    <!--        <el-carousel :interval="5000" arrow="always">-->
    <!--          <el-carousel-item v-for="item in 1" :key="item">-->
    <!--            <img src="../../../static/image/main/mainMap.png" style="width: 100%;height: 100%">-->
    <!--          </el-carousel-item>-->
    <!--        </el-carousel>-->
    <!--      </div>-->
    <!--    </el-col>-->
    <!--  </el-row>-->
    <div style="display: flex">
        <img class="main-headerImg-img" src="../../../static/image/main/mainMap.jpg" v-if="headImg==null">
        <img class="main-headerImg-img" :src="headImg.homePage.headImage" v-else>
    </div>
</template>

<script>
export default {
  name: 'HeaderImg',
  props: {
    headImg: {
      type: Object
    }
  },
  data() {
    return {
      Img: null
    }
  }

  }
</script>

<style scoped>
</style>

<style>
    .main-headerImg-img {
        width: 100%;
        height: 100%;
    }

    .header-img-box > .el-carousel--horizontal .el-carousel__container {
        height: 700px;
    }
</style>
